"use strict";

var _toConsumableArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCancellablePromises = void 0;

var react_1 = require("react");

var useCancellablePromises = function useCancellablePromises() {
  var pendingPromises = (0, react_1.useRef)([]);
  var appendPendingPromise = (0, react_1.useCallback)(function (promise) {
    pendingPromises.current = [].concat(_toConsumableArray(pendingPromises.current), [promise]);
  }, []);
  var removePendingPromise = (0, react_1.useCallback)(function (promise) {
    pendingPromises.current = pendingPromises.current.filter(function (p) {
      return p !== promise;
    });
  }, []);
  var clearPendingPromises = (0, react_1.useCallback)(function () {
    return pendingPromises.current.map(function (p) {
      return p.cancel();
    });
  }, []);
  var api = (0, react_1.useMemo)(function () {
    return {
      appendPendingPromise: appendPendingPromise,
      removePendingPromise: removePendingPromise,
      clearPendingPromises: clearPendingPromises
    };
  }, [appendPendingPromise, clearPendingPromises, removePendingPromise]);
  return api;
};

exports.useCancellablePromises = useCancellablePromises;